﻿﻿﻿<div class="userhistoryDialogue">
    <mat-tab-group mat-stretch-tabs="false" [selectedIndex]="0">
        <mat-tab>
            <ng-template mat-tab-label>
                Change Log: Lever {{label}}
            </ng-template>
            <div #tableBody class="custom_small_panelbody_fix">
                <table #historyTable mat-table
                       [dataSource]="dataSource"
                       multiTemplateDataRows
                       class="mat-elevation-z8 mat-table-custom">

                    <ng-container matColumnDef="contact">
                        <th mat-header-cell *matHeaderCellDef>Contact</th>
                        <td mat-cell *matCellDef="let row">
                            {{row.Contact}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Action</th>
                        <td mat-cell *matCellDef="let row">
                            <textareaoverlay [inputControls]="{
                                        isOpenOverlay: isOpenTextAreaOverlay,
                                        textAreaId: 'Action_ta_' + row.index,
                                        isEditable: false,
                                        maxCommentLength: 4000,
                                        comment: row.Action
                                    }">
                            </textareaoverlay>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="notes">
                        <th mat-header-cell *matHeaderCellDef>Notes</th>
                        <td mat-cell *matCellDef="let row">
                            <textareaoverlay [inputControls]="{
                                         isOpenOverlay: isOpenTextAreaOverlay,
                                         textAreaId: 'Notes_ta_' + row.index,
                                         isEditable: false,
                                         maxCommentLength: 4000,
                                         comment: row.Notes
                                     }">
                            </textareaoverlay>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="bestpractices">
                        <th mat-header-cell *matHeaderCellDef>Best Practices</th>
                        <td mat-cell *matCellDef="let row">
                            <textareaoverlay [inputControls]="{
                                         isOpenOverlay: isOpenTextAreaOverlay,
                                         textAreaId: 'BestPractices_ta_' + row.index,
                                         isEditable: false,
                                         maxCommentLength: 4000,
                                         comment: row.BestPractices
                                     }">
                            </textareaoverlay>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="priority">
                        <th mat-header-cell *matHeaderCellDef>Priority</th>
                        <td mat-cell *matCellDef="let row">
                            <textareaoverlay [inputControls]="{
                                        isOpenOverlay: isOpenTextAreaOverlay,
                                        textAreaId: 'Priority_ta_' + row.index,
                                        isEditable: false,
                                        maxCommentLength: 4000,
                                        comment: row.Priority
                                    }">
                            </textareaoverlay>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="improvement">
                        <th mat-header-cell *matHeaderCellDef>Improvement</th>
                        <td mat-cell *matCellDef="let row">
                            <textareaoverlay [inputControls]="{
                                isOpenOverlay: isOpenTextAreaOverlay,
                                textAreaId: 'Improvement_ta_' + row.index,
                                isEditable: false,
                                maxCommentLength: 4000,
                                comment: row.KpiName
                            }">
                            </textareaoverlay>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="comments">
                        <th mat-header-cell *matHeaderCellDef>Comments</th>
                        <td mat-cell *matCellDef="let row">
                            <textareaoverlay [inputControls]="{
                                        isOpenOverlay: isOpenTextAreaOverlay,
                                        textAreaId: 'DiscussedComments_ta_' + row.index,
                                        isEditable: false,
                                        maxCommentLength: 4000,
                                        comment: row.DiscussedComments
                                    }">
                            </textareaoverlay>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef>User</th>
                        <td mat-cell *matCellDef="let row">
                            {{row.CreatedBy}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>UTC Date</th>
                        <td mat-cell *matCellDef="let row">
                            {{datePipe.transform(row.CreatedAtUtc,'yyyy-MM-dd HH:mm')}}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;">
                    </tr>
                </table>
            </div>
        </mat-tab>
    </mat-tab-group>
    <br />
    <div style="text-align:center">
        <button mat-raised-button class="btn button-color-fix-red " (click)="close()">
            <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
            Back
        </button>
    </div>
    <br />
</div>



